import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  courses: [],
  coursesRef: null,
  coursesModuleLoaded: false,
  courseToCopy: null
}

const getters = {
  courses (state) {
    return state.courses.reverse()
  },
  coursesRef (state) {
    return state.coursesRef
  },
  coursesModuleLoaded (state) {
    return state.coursesModuleLoaded
  },
  courseToCopy (state) {
    return state.courseToCopy
  },
  courseByUrl (state) {
    return (courseUrl) => {
      return state.courses.find(c => {
        return c.url === courseUrl
      })
    }
  },
  courseByKey (state) {
    return (courseKey) => {
      return state.courses.find(c => {
        return c.key === courseKey
      })
    }
  },
  linkedCourses (state) {
    return (courseKey) => {
      let course = state.courses.find(c => c.key === courseKey)
      let linked = []
      let nameA = ''
      let nameB = ''
      for (let c of state.courses) {
        if (course.type === 'Live' && c.type === 'Live') {
          nameA = course.name.split(' ').splice(1, course.name.split(' ').length).join(' ')
          nameB = c.name.split(' ').splice(1, c.name.split(' ').length).join(' ')
          if (nameA === nameB) linked.push(c)
        } else if (course.name === c.name) linked.push(c)
      }
      return linked
    }
  }
}

const mutations = {
  setCourses (state, payload) {
    state.courses = payload
  },
  setCoursesRef (state, payload) {
    state.coursesRef = payload
  },
  setCoursesModuleLoaded (state, payload) {
    state.coursesModuleLoaded = payload
  },
  setCourseToCopy (state, payload) {
    state.courseToCopy = payload
  }
}

const actions = {
  loadCourses: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('courses')
    ref.on('value', snapshot => {
      const courses = []
      snapshot.forEach(c => {
        courses.push({...c.val(), key: c.key})
      })
      store.commit('setCoursesRef', ref)
      store.commit('setCourses', courses)
      store.dispatch('loadUsers').then(() => {
        store.dispatch('loadContent').then(() => {
          store.commit('setCoursesModuleLoaded', true)
          resolve()
        })
      })
    })
  }),
  setCourseToCopy (store, payload) {
    store.commit('setCourseToCopy', payload)
  },
  createCourse: (store, payload) => new Promise((resolve, reject) => {
    const newCourse = {...payload}
    store.getters.coursesRef.push(newCourse).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateCourse: (store, payload) => new Promise((resolve, reject) => {
    const newCourse = {...payload}
    store.getters.coursesRef.child(newCourse.key).set(newCourse).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  addStudent: (store, payload) => new Promise((resolve, reject) => {
    const newProgress = {...payload}
    firebase.database().ref('progress').push(newProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  removeStudent: (store, payload) => new Promise((resolve, reject) => {
    const newProgress = {...payload}
    firebase.database().ref('progress').set(newProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetCourses: (store) => new Promise((resolve, reject) => {
    if (store.getters.coursesRef) store.getters.coursesRef.off()
    store.commit('setCourses', [])
    store.commit('setCoursesRef', null)
    resolve()
  }),
  resetCoursesModule (store) {
    store.dispatch('resetCourses').then(() => {
      store.commit('setCoursesModuleLoaded', false)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/courses/courses.js